// ABOUTME: Custom hook for SharePoint file formatting utilities
// ABOUTME: Provides formatting functions for file size, date, and other display utilities

import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { formatDate, formatFileSize } from '../utils/formatters';

type IUseFileFormattingReturn = {
    readonly formatFileSize: (bytes?: number) => string;
    readonly formatDate: (date?: string) => string;
};

export const useFileFormatting = (): IUseFileFormattingReturn => {
    const intl = useIntl();

    const formatFileSizeCallback = useCallback((bytes?: number) => formatFileSize(bytes), []);

    const formatDateCallback = useCallback(
        (date?: string) => formatDate(date, intl.locale),
        [intl.locale],
    );

    return {
        formatFileSize: formatFileSizeCallback,
        formatDate: formatDateCallback,
    };
};
